import { Table } from "./../models/contracts/table"
import {
  CustomURLEncoder,
  isNullOrUndefined,
} from "src/app/core/helpers/http-params-extensions"
import { Injectable } from "@angular/core"
import { environment } from "src/environments/environment"
import { HttpClient, HttpParams } from "@angular/common/http"
import {
  IntegrationTenantPaginateRequest,
  PendingGoogleDeleteRequest,
  ViewDetailsIntegration,
} from "../models/integrations/google-integration"

@Injectable({
  providedIn: "root",
})
export class GoogleIntegrationService {
  private post_association: string
  private post_registration_pending_url: string
  private get_paginate_url: string
  private get_integrations_paginate: string
  private get_service_configuration_id: string
  private get_integrations_id: string
  private get_integration_validation: string
  private put_configuration_integration: string
  private delete_integration: string
  private post_pendings_clean: string

  private buildUrlsIntegration(googleIntegratorUrl: string) {
    this.post_association = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.association}`
    this.get_paginate_url = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.get_paginate}`
    this.get_integrations_paginate = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.get_integrations_paginate}`
    this.get_service_configuration_id = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.service_configuration_id}`
    this.get_integrations_id = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.get_integrations}`
    this.get_integration_validation = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.get_validation_integration}`
    this.put_configuration_integration = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.put_configuration_integration}`
    this.delete_integration = `${googleIntegratorUrl}${environment.endPointGoogleIntegration.routes.delete_integration}`
  }
  private buildUrls(googleIntegratorUrl: string) {
    this.post_registration_pending_url = `${googleIntegratorUrl}${environment.endPointPendings.routes.post_registration_pending_url}`
    this.post_pendings_clean = `${googleIntegratorUrl}${environment.endPointPendings.routes.post_pendings_clean}`
  }

  constructor(private httpClient: HttpClient) {
    this.buildUrlsIntegration(environment.endPointGoogleIntegration.url)
    this.buildUrls(environment.endPointPendings.url)
  }

  getListIntegrations(tenantId: string, group: any) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    params = params.set("DataSize", String(group.DataSize))
    params = params.set("Page", String(group.Page))

    if (!isNullOrUndefined(tenantId)) {
      params = params.set("TenantId", String(tenantId))
    }

    if (!isNullOrUndefined(group.orderByFilter)) {
      params = params.set("OrderByFilter", String(group.OrderByFilter))
    }
    if (!isNullOrUndefined(group.isDesc)) {
      params = params.set("IsDesc", String(group.IsDesc))
    }

    return this.httpClient.get(this.get_paginate_url, { params })
  }

  getListIntegrationsAll(request: IntegrationTenantPaginateRequest) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    params = params.set("DataSize", String(request.DataSize))
    params = params.set("Page", String(request.Page))

    return this.httpClient.get(this.get_integrations_paginate, { params })
  }

  getdetailsIntegration(serviceConfigurationId) {
    return this.httpClient.get(
      this.get_service_configuration_id.replace(
        "{serviceConfigurationId}",
        serviceConfigurationId
      )
    )
  }

  postIntegration(dataObject) {
    return this.httpClient.post(this.post_association, dataObject)
  }

  getIntegrationsFather(integrationId) {
    return this.httpClient.get(
      this.get_integrations_id.replace("{integrationId}", integrationId)
    )
  }
  postRegistrationPending(tenantId, pendingType, items?: any) {
    return this.httpClient.post(
      this.post_registration_pending_url
        .replace("{tenantId}", tenantId)
        .replace("{pendingType}", pendingType),
      items
    )
  }

  getValidationIntegrationeconomicGroup(param) {
    let params = new HttpParams({ encoder: new CustomURLEncoder() })

    params = params.set("IntegrationId", String(param.serviceId))
    params = params.set("Subdomain", String(param.subdomain))
    params = params.set("UnitOrganization", String(param.organizationalUnit))

    return this.httpClient.get(this.get_integration_validation, { params })
  }

  putConfigurationIntegration(dataObject: ViewDetailsIntegration) {
    return this.httpClient.put(this.put_configuration_integration, dataObject)
  }

  deleteIntegration(referenceId: string) {
    return this.httpClient.delete(
      this.delete_integration.replace("{referenceId}", referenceId)
    )
  }

  cleanPendings(dataObject: PendingGoogleDeleteRequest) {
    return this.httpClient.post(this.post_pendings_clean, dataObject)
  }
}
